var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 10.5182V14.391H17.5818C17.3454 15.6364 16.6363 16.691 15.5726 17.4001L18.8181 19.9183C20.709 18.1729 21.7999 15.6092 21.7999 12.5638C21.7999 11.8547 21.7363 11.1728 21.6181 10.5184L12.2 10.5182Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59563 14.2398L5.86366 14.8001L3.27271 16.8183C4.91816 20.0819 8.29063 22.3365 12.1997 22.3365C14.8996 22.3365 17.1632 21.4455 18.8178 19.9183L15.5724 17.4001C14.6815 18.0001 13.5451 18.3638 12.1997 18.3638C9.59971 18.3638 7.39068 16.6092 6.59971 14.2456L6.59563 14.2398Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27284 7.85464C2.59106 9.20004 2.2002 10.7182 2.2002 12.3364C2.2002 13.9546 2.59106 15.4728 3.27284 16.8182C3.27284 16.8272 6.60017 14.2363 6.60017 14.2363C6.40018 13.6363 6.28196 13 6.28196 12.3363C6.28196 11.6726 6.40018 11.0363 6.60017 10.4363L3.27284 7.85464Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 6.31827C13.6726 6.31827 14.9817 6.82735 16.0272 7.80918L18.8908 4.94558C17.1544 3.32743 14.8999 2.33646 12.1999 2.33646C8.29084 2.33646 4.91816 4.58191 3.27271 7.85464L6.59993 10.4365C7.39079 8.0728 9.59991 6.31827 12.1999 6.31827Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLoginIcon);
export default __webpack_public_path__ + "static/media/Google_login_icon.918fcac864f5ce087ab0059fd9f3bbde.svg";
export { ForwardRef as ReactComponent };